/**
 * Checks if value is a function.
 *
 * @param obj - Value to check
 * @returns True if function
 */
export const is_function = obj => typeof obj === "function"
